module.exports = __webpack_public_path__ + "media/images/home/honest-renovations-89184a2e2063642a413c173241aa3586.jpg";